export enum PermissionType {
	"NONE" = 0,
	"GUEST" = 1,
	"USER" = 2,
	"EDITOR" = 3,
	"ADMINISTRATOR" = 4,
}
